import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState, useRef } from "react";
import { routes } from "../config/routesConfig";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import logo from "../assets/icons/mocionLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  changePremission,
  selectClub,
  selectClubThunk,
  setClubs,
  setLang,
  UserSliceType,
} from "../lib/redux/slices/userSlice";

import NavBarProfile from "./NavBarProfile";
import usePreNavigation from "../hooks/usePreNavigation";
import { FORM_ROUTES } from "../constants";
import { checkPath, cn, handleTabName } from "../utils/utils";
import Button from "../components/global/Button";
import Modal from "../components/global/Modal";
import { useGetDictionary } from "../hooks/useGetDictionary";
import { Tooltip } from "react-tooltip";
import Select from "react-select";
import { selectStyle, selectTheme } from "../styles/selectStyles";
import { DictionaryType } from "../types";
import DarkModeToggle from "../components/global/DarkModeToggle";
import ImageIcon from "../components/global/ImageIcon";
import MessageIcon from "../assets/icons/MessageIcon";
import NotificationsIcon from "../assets/icons/NotificationsIcon";
import { useGetNotificationsQuery } from "../lib/redux/services/sections/ChatAndNotification";
type Props = {
  openHelpCenter: boolean;
  setOpenHelpCenter: React.Dispatch<React.SetStateAction<boolean>>;
};

function Navbar({ openHelpCenter, setOpenHelpCenter }: Props) {
  // function to confirm navigation depending on the current path and the list of forms paths
  // you must add this fuction to any link or button that navigates to another page
  // with preventDefault() to avoid the default behavior of the browser
  // const handleNavigation = usePreNavigation(async (path) => {
  //

  //   if (checkPath(window.location.pathname)) {
  //     return window.confirm("Are you sure you want to leave?");
  //   }
  //   return true;
  // });
  const { shared, profile }: DictionaryType = useGetDictionary();
  const { onCancel, onSuccess, CustomNavigate } = usePreNavigation(null, {
    isCustom: true,
  });
  const { data, isSuccess, isLoading, isFetching } = useGetNotificationsQuery(
    {}
  );
  const [openModel, setOpenModel] = useState(false);
  const { navbar }: DictionaryType = useGetDictionary();
  const path = useLocation().pathname;
  const [searchParams] = useSearchParams();
  const [isHasUnReadedMsgs, setIsHasUnReadedMsgs] = useState(false);
  const user_stage = useSelector((state: any) => state?.user?.stage);
  const user_status = useSelector((state: any) => state?.user?.status);
  const location = useLocation();
  const navigate = useNavigate();
  const [notAccessibleTitles, setNotAccessibleTitles] = useState<
    { key: string; value: string }[]
  >([]);

  const [queryParams, setQueryParams] = useState<
    { key: string; value: string }[]
  >([]);
  useEffect(() => {
    if (location.state) {
      setNotAccessibleTitles(location.state.notAccessibleTitles);
    }
  }, [location.state, location]);

  const hiddenKeys = [
    "id",
    "section",
    "max",
    "price",
    "min",
    "currentPage",
    "currentSize",
    "booking_type"
  ];

  const clubs = localStorage.getItem("clubs");
  const selectedClub = localStorage.getItem("clubId");
  const reduxLang = useSelector((state: any) => state?.user?.lang);
  const lang = localStorage.getItem("lang") || reduxLang;
  const clubsRedux = useSelector((state: UserSliceType) => state.user.clubs);
  const dispatch = useDispatch();

  const [navInfo, setNavInfo] = useState<any>({});

  useEffect(() => {
    if (clubs && selectedClub) {
      dispatch(setClubs(JSON.parse(clubs)));
      if (JSON.parse(clubs).length > 0) {
        //@ts-ignore
        dispatch(selectClubThunk(parseInt(selectedClub)));
        changePremission({ club_id: selectedClub });
      }
    }
  }, [clubs, selectedClub, user_stage]);
  const handleNavbarInfo = () => {
    let PathWithoutQuery = path.split("?")[0];

    const navInfo = routes.find((item) => {
      let currentItem = item;
      let currentPath = PathWithoutQuery;
      if (item.path.indexOf(":") !== -1) {
        //

        currentItem = { ...item, path: item.path.split(":")[0] };
        currentPath = currentPath.slice(0, currentPath.lastIndexOf("/"));
        //
        return (
          currentItem.path === currentPath ||
          currentItem.path === currentPath + "/" ||
          currentItem.path === currentPath.substring(0, currentPath.length - 1)
        );
      } else {
        return (
          item.path === PathWithoutQuery ||
          item.path === PathWithoutQuery + "/" ||
          item.path ===
            PathWithoutQuery.substring(0, PathWithoutQuery.length - 1)
        );
      }
    });
    setNavInfo(navInfo);
  };
  useEffect(() => {
    const tempQueryParams: { key: string; value: string }[] = [];
    searchParams.forEach((valueEl, keyEl) => {
      if (!hiddenKeys.includes(keyEl)) {
        tempQueryParams.push({ value: valueEl, key: keyEl });
      }
    });
    setQueryParams(tempQueryParams);
    handleNavbarInfo();
  }, [path, window.location.search]);
  useEffect(() => {
    if (data && isSuccess) {
      console.log(data);
      const isThereUnReadedMsgs = data?.data?.some(
        (item: any) => item.read === false
      );
      setIsHasUnReadedMsgs(isThereUnReadedMsgs);
    }
  }, [data, isSuccess, isLoading, isFetching]);
  const status_tooltip =
    user_status == "Complete your profile"
      ? profile.profile_status?.complete_your_profile_message
      : user_status == "Suspended"
      ? profile.profile_status?.suspended_message
      : user_status == "Cancelled"
      ? profile.profile_status?.cancelled_message
      : user_status == "Under review"
      ? profile.profile_status?.under_review_message
      : user_status == "Active"
      ? profile.profile_status?.active_message
      : "";

  const languages = [
    { value: "en", label: "En" },
    { value: "ar", label: "ع" },
  ];
  const Roles = useSelector(
    //@ts-ignore
    (state: UserSliceType) => state.user.currentPremission
  );
  return (
    <nav className=" p-4 ">
      <div className="content flex justify-between items-center  bg-[#fff] dark:bg-primaryLight z-50 w-full bg-dark-1 px-6 py-4 lg:px-19 rounded-2xl custom-shadow">
        <div className="flex gap-1 items-center">
          <div className="xl:max-w-[42px] xl:min-w-[42px] max-w-[35px] min-w-[35px] bg-primary text-white rounded-2xl p-2">
            {navInfo?.icon && navInfo.icon(32, 32)}
          </div>

          <span className="font-bold text-lg xl:text-2xl text-primary dark:text-white flex gap-2 items-center">
            <span
              className="cursor-pointer "
              onClick={() => {
                if (navInfo?.redirect !== navInfo?.path) {
                  navigate(`${navInfo?.redirect}`);
                }
              }}
            >
              {/* @ts-ignore */}
              {(navbar && navInfo?.title && navbar[navInfo?.title]) ||
                 navInfo?.title}
            </span>
            {navInfo?.subNavs &&
              navInfo?.subNavs
                ?.filter((item: any) => item.position !== "last")
                .map((item: any, index: any) => {
                  return (
                    <span
                      className={cn(
                        "flex gap-2 items-center   capitalize",
                        item.link && "cursor-pointer"
                      )}
                      key={item?.title}
                      onClick={() => {
                        if (item.link) {
                          navigate(item.link);
                        }
                      }}
                    >
                      {" "}
                      {index == 0 && (
                        <ChevronRight className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8" />
                      )}
                      {/* @ts-ignore */}
                      {(navbar && item?.title && navbar[item?.title]) ||
                        item?.title}
                      {index !==
                        navInfo?.subNavs?.filter(
                          (item: any) => item.position !== "last"
                        ).length -
                          1 && (
                        <ChevronRight className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8" />
                      )}
                    </span>
                  );
                })}
            {/* {notAccessibleTitles && notAccessibleTitles.map((item, index) => {
                
                return (
                  <span
                    className="flex gap-2 items-center  capitalize"
                    key={item?.key}
                  >
                    {index === 0 && <ChevronRight />}
                    {item?.value}
                    {index !== notAccessibleTitles.length - 1 && <ChevronRight />}
                  </span>
                );
              })} */}
            {queryParams.length > 0 &&
              queryParams.map((item, index) => {
                return (
                  <span
                    className="flex gap-2 items-center  capitalize"
                    key={item?.key}
                  >
                    {index == 0 &&
                      (lang == "ar" ? (
                        <ChevronLeft
                          className=" min-w-6 max-w-6  xl:max-w-6 xl:min-w-8"
                          color="#1E1850"
                        />
                      ) : (
                        <ChevronRight
                          className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8"
                          color="#1E1850"
                        />
                      ))}

                    <p className="truncate max-w-[150px] 2xl:whitespace-normal 2xl:max-w-none">
                      {/* @ts-ignore */}
                      {(navbar && item?.value && handleTabName(item,navbar?.tabs)) ||
                        // (item?.value?.length > 15
                        //   ? `${item?.value?.slice(0, 15)}...:`
                        item?.value}
                    </p>
                    {index !== queryParams.length - 1 &&
                      (lang == "ar" ? (
                        <ChevronLeft
                          className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8"
                          color="#1E1850"
                        />
                      ) : (
                        <ChevronRight
                          className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8"
                          color="#1E1850"
                        />
                      ))}
                  </span>
                );
              })}
            {navInfo?.subNavs
              ?.filter((item: any) => item.position === "last")
              .map((item: any, index: any) => {
                return (
                  <span
                    className={cn(
                      "flex gap-2 items-center   capitalize",
                      item.link && "cursor-pointer"
                    )}
                    key={item?.title}
                    onClick={() => {
                      if (item.link) {
                        navigate(item.link);
                      }
                    }}
                  >
                    {" "}
                    {index == 0 && (
                      <ChevronRight className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8" />
                    )}
                    {/* @ts-ignore */}
                    {(navbar && item?.title && navbar[item?.title]) ||
                      item?.title}
                    {index !==
                      navInfo?.subNavs?.filter(
                        (item: any) => item.position === "last"
                      ).length -
                        1 && (
                      <ChevronRight className="min-w-6 max-w-6  xl:max-w-6 xl:min-w-8" />
                    )}
                  </span>
                );
              })}
          </span>
        </div>
        <Tooltip
          id={"user-status"}
          className=" text-sm 2xl:text-base"
          content={status_tooltip}
          style={{
            backgroundColor: "#CBDB2A",
            color: "#1e1850",
            zIndex: 2,
          }}
          place="bottom"
        />

        <div className="flex gap-4 items-center">
          {/* <select
            className="flex p-3 h-[inherit] cursor-pointer max-w-[130px] w-fit dark:bg-primaryLight text-primary dark:text-white   outline-none  customScroll"
            title="lang"
            onChange={(e) => {
              dispatch(setLang(e.target.value));
              localStorage.setItem("lang", e.target.value);
            }}
          >
            {languages &&
              languages?.map((item: any, index: number) => (
                <option
                  key={index}
                  value={item.value}
                  //@ts-ignore
                  selected={item.value === lang}
                >
                  {item.label}
                </option>
              ))}
          </select> */}

          <div
            data-tooltip-id="user-status"
            className={cn("bg-[#F3F4F6] dark:bg-primaryLight min-w-[96px] h-[40px] grid place-content-center border-[#9CA3AF] border rounded-full text-center",user_status ==="Active" && 'border-[#009A27] bg-transparent py-1')}
          >
            <p className={cn(" px-2 text-sm 2xl:text-base flex gap-1 items-center",user_status ==="Active" && 'text-[#009A27]')}>
              
              <span className="bg-[#009A27] w-3 h-3 rounded-full block"></span>
              {/* @ts-ignore */}
              {profile.profile_status && profile.profile_status[user_status]}
            </p>
          </div>
          <div className="list">
            <ul className="flex  gap-4 items-baseline ">
              {Roles?.find(
                (role: any) => role?.section?.toLowerCase() === "notifications"
              )?.read === true && (
                <li
                  className="cursor-pointer relative border border-[#66666659] rounded-full p-1 w-[40px] h-[40px]"
                  onClick={(e) => {
                    e.preventDefault();
                    CustomNavigate("/notification");
                    if (FORM_ROUTES.includes(window.location.pathname)) {
                      setOpenModel(true);
                    } else {
                      onSuccess("/notification");
                    }
                  }}
                >
                  {isHasUnReadedMsgs && (
                    <span className="w-3 h-3 bg-primaryRed rounded-full block absolute right-1"></span>
                  )}
                   <Tooltip
                                  id="notification-tooltip"
                                  style={{
                                    backgroundColor: "#ccc",
                                    color: "#1e1850",
                                    fontWeight: "bold",
                                    
                                    top: "0px",
                                    zIndex: 1000,
                                  }}
                                  place="top"
                                />
                              <div
                               data-tooltip-id="notification-tooltip"
                              data-tooltip-content="Notifications"
                              >
                                 <ImageIcon
                    className="min-w-8"
                    Icon={NotificationsIcon}
                    width={23}
                    height={23}
                  />
                              </div>
                 
                </li>
              )}
              {Roles?.find(
                (role: any) => role?.section?.toLowerCase() === "chat"
              )?.read === true && (
                <li
                  className="cursor-pointer border border-[#66666659] rounded-full p-1 w-[40px] h-[40px]"
                  onClick={(e) => {
                    e.preventDefault();
                    CustomNavigate("/chat");
                    if (FORM_ROUTES.includes(window.location.pathname)) {
                      setOpenModel(true);
                    } else {
                      onSuccess("/chat");
                    }
                  }}
                >
                   <Tooltip
                                  id="chat-tooltip"
                                  style={{
                                    backgroundColor: "#ccc",
                                    color: "#1e1850",
                                    fontWeight: "bold",
                                    
                                    top: "0px",
                                    zIndex: 1000,
                                  }}
                                  place="top"
                                />
                              
                                  
                   <div
                   data-tooltip-id="chat-tooltip"
                                  data-tooltip-content="Chat"
                   >
                    <ImageIcon
                    className="min-w-8"
                    Icon={MessageIcon}
                    width={23}
                    height={23}
                  /></div>
                  
                </li>
              )}
              {/* <li>
                <DarkModeToggle />
              </li> */}
            </ul>
          </div>

          <div className="dropMenu flex gap-5 items-center relative h-[40px]">
            {clubsRedux.length == 0 && (
              <Tooltip
                id={"clubs-select"}
                content={"no clubs yet"}
                style={{
                  backgroundColor: "#CBDB2A",
                  color: "#1e1850",
                  zIndex: 2,
                }}
                place="bottom"
              />
            )}
            <div data-tooltip-id="clubs-select" className="dropMenu__Box border border-[#66666659] rounded-xl px-2 pr-4  h-[40px]">
              <select
                name=""
                id=""
                className="flex p-3 py-2 h-[38px] cursor-pointer max-w-[130px] w-fit text-primary dark:text-white   outline-none  customScroll dark:bg-primaryLight   "
                title="Club name here"
                onChange={(e) => {
                  //@ts-ignore
                  dispatch(selectClubThunk(parseInt(e.target.value)));
                  localStorage.setItem("clubId", e.target.value);
                }}
              >
                {clubsRedux &&
                  clubsRedux?.map((item: any, index: number) => (
                    <option
                      key={index}
                      value={item.id}
                      //@ts-ignore
                      selected={item.id === +selectedClub}
                    >
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* <Select
              components={{
                IndicatorSeparator: () => null,
              }}
              getOptionLabel={(option: any) => option.name}
              getOptionValue={(option: any) => option.id}
              styles={selectStyle}
classNamePrefix="react-select"
              theme={selectTheme}
              className="border-white min-w-[150px]"
              options={clubs ? JSON.parse(clubs) : []}
              onChange={(selected) => {
                // @ts-ignore
                return dispatch(selectClub(selected.id));
              }}
              //@ts-ignore
              ref={selectedRef}
            /> */}

            {/* <div className="dropMenu__Box flex gap-2 items-center">
              <span className="text-red-500  ">user 1</span>
              <img loading="lazy"
                src="https://images.unsplash.com/photo-1496449903678-68ddcb189a24?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt=""
                className="rounded-full w-[50px] h-[50px] object-cover"
              />
              <div ref={dropDownRef}>
                {openDropDown && (
                  <DropDownBox
                    dropDownConfig={coachDropDown}
                    title=""
                    closeDropDown={closeDropDown}
                    className=" absolute top-10 right-[20px]  w-[150px]  "
                  />
                )}
              </div>
            </div> */}
            <NavBarProfile
              openHelpCenter={openHelpCenter}
              setOpenHelpCenter={setOpenHelpCenter}
            />
          </div>
        </div>
      </div>
      <div className=" fixed z-50">
        <Modal modalMaxWidth="max-w-lg" isOpen={openModel}>
          <div className="  flex flex-col gap-8 px-12 py-5 ">
            <div className="flex flex-col justify-center items-center gap-4 text-center ">
              <img
                loading="lazy"
                width={200}
                height={200}
                src={logo}
                alt="mocion-logo"
              />
              <div>
                <h2>{shared.attention}!!</h2>
                <p className="text-lg font-normal  text-[#1E1850] break-words leading-relaxed whitespace-pre-wrap  ">
                  {shared.discard_changes}
                </p>
              </div>
              <div className="mt-6 flex flex-col items-center justify-center gap-6  w-full">
                <Button
                  customeStyle=" bg-primary text-white  w-full rounded-full  text-lg py-4  "
                  text={shared.yes}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                    onSuccess();
                    setOpenModel(false);
                  }}
                />
                <Button
                  customeStyle="bg-white text-primary dark:text-white   w-full rounded-full text-lg py-4 "
                  text={shared.no}
                  width="max-w-[400px] w-full"
                  onClick={() => {
                    onCancel();
                    setOpenModel(false);
                  }}
                />
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </nav>
  );
}

export default Navbar;
